var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "product-app" }, [
    _c("div", { staticClass: "container-fluid product-search-container" }, [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-sm-12 offset-lg-3 col-lg-6 product-search" },
            [
              _c(
                "form",
                {
                  on: {
                    submit: function($event) {
                      $event.preventDefault()
                      return _vm.InitSearch($event)
                    }
                  }
                },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.searchQuery,
                        expression: "searchQuery"
                      }
                    ],
                    attrs: {
                      type: "text",
                      name: "product-page-search",
                      id: "product-page-search",
                      placeholder: _vm.translations.searchproducts,
                      "aria-label": _vm.translations.searchproducts
                    },
                    domProps: { value: _vm.searchQuery },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.searchQuery = $event.target.value
                      }
                    }
                  }),
                  _vm._v(" "),
                  _vm.searchQuery !== ""
                    ? _c(
                        "span",
                        {
                          staticClass: "product-search-clear",
                          attrs: { id: "product-search-clear" },
                          on: { click: _vm.clearSearch }
                        },
                        [_c("span", { staticClass: "fas fa-times" })]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._m(0)
                ]
              )
            ]
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "container" }, [
      _vm._m(1),
      _vm._v(" "),
      _c("div", { staticClass: "row justify-content-end" }, [
        _vm.categories && _vm.categories.length
          ? _c(
              "div",
              { staticClass: "col-sm-6 col-lg-6 product-category selectdiv" },
              [
                _c("span", { staticClass: "special-diet" }, [
                  _c(
                    "button",
                    {
                      staticClass: "special-diet-btn",
                      on: {
                        click: function($event) {
                          _vm.categoriesVisible = !_vm.categoriesVisible
                          _vm.tontonsVisible = false
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n                        Rajaa kategorian perusteella "
                      ),
                      _vm._m(2)
                    ]
                  )
                ])
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "col-sm-6 col-lg-6 special-diet" }, [
          _c("span", { staticClass: "special-diet" }, [
            _vm.specialDiet
              ? _c(
                  "button",
                  {
                    staticClass: "special-diet-btn",
                    on: {
                      click: function($event) {
                        _vm.tontonsVisible = !_vm.tontonsVisible
                        _vm.categoriesVisible = false
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n                        Rajaa ruokavalion perusteella "
                    ),
                    _vm._m(3)
                  ]
                )
              : _vm._e()
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-12 special-diet mt-2 mb-2" },
          [
            _c(
              "slide-up-down",
              { attrs: { active: _vm.categoriesVisible, duration: 500 } },
              _vm._l(_vm.categories, function(category, i) {
                return _c(
                  "button",
                  {
                    key: category.name,
                    class: [
                      { active: category.id == _vm.selectedCategory },
                      "category btn",
                      "a" + category.id
                    ],
                    attrs: { value: category.id },
                    on: {
                      click: function($event) {
                        _vm.selectCategory(category.id)
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n                        " +
                        _vm._s(category.name) +
                        "\n                    "
                    )
                  ]
                )
              })
            ),
            _vm._v(" "),
            _vm.specialDiet
              ? _c(
                  "slide-up-down",
                  { attrs: { active: _vm.tontonsVisible, duration: 500 } },
                  [
                    _c(
                      "div",
                      { staticClass: "special-diet-filters" },
                      _vm._l(_vm.sortedTontons, function(tonton, i) {
                        return _c(
                          "button",
                          {
                            key: i,
                            class: [
                              { active: _vm.activeTontons.includes(tonton) },
                              "tonton"
                            ],
                            on: {
                              click: function($event) {
                                _vm.toggleTonton(i)
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(tonton.name) +
                                "\n                        "
                            )
                          ]
                        )
                      })
                    )
                  ]
                )
              : _vm._e()
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "row campaign-row" },
        _vm._l(_vm.campaigns, function(campaign, i) {
          return _c("div", { key: i, staticClass: "col-sm-6 col-lg-3" }, [
            _c(
              "label",
              {
                class: ((_obj = {
                  "campaign-label": true,
                  "campaign-inactive": !campaign.on
                }),
                (_obj[campaign.name + "-label"] = true),
                _obj),
                on: {
                  click: function($event) {
                    _vm.toggleCampaign(i)
                  }
                }
              },
              [
                _c("span", [
                  _c("i", {
                    class: ((_obj$1 = { fas: true }),
                    (_obj$1[campaign.icon] = true),
                    _obj$1)
                  })
                ]),
                _vm._v(_vm._s(campaign.title))
              ]
            )
          ])
          var _obj
          var _obj$1
        })
      ),
      _vm._v(" "),
      _c("div", { staticClass: "row erase-row" }, [
        _c("div", { staticClass: "col-12" }, [
          _vm.selectedCategory
            ? _c(
                "button",
                {
                  staticClass: "erase",
                  attrs: { id: "erase-category" },
                  on: {
                    click: function($event) {
                      _vm.clearCategory()
                    }
                  }
                },
                [_vm._v("Pyyhi kategoriat X")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.allCampaigns != true
            ? _c(
                "button",
                {
                  staticClass: "erase",
                  attrs: { id: "erase-campaign" },
                  on: {
                    click: function($event) {
                      _vm.clearCampaign()
                    }
                  }
                },
                [_vm._v("Pyyhi kampanjat X")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.allDiets != true
            ? _c(
                "button",
                {
                  staticClass: "erase",
                  attrs: { id: "erase-diets" },
                  on: {
                    click: function($event) {
                      _vm.clearTontons()
                    }
                  }
                },
                [_vm._v("Pyyhi ruokavaliot X")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.selectedCategory ||
          _vm.allCampaigns != true ||
          _vm.allDiets != true
            ? _c(
                "button",
                {
                  staticClass: "erase",
                  attrs: { id: "erase-all" },
                  on: {
                    click: function($event) {
                      _vm.clearAll()
                    }
                  }
                },
                [_vm._v("Pyyhi kaikki X")]
              )
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "products" },
        [
          _c("product-list", {
            attrs: {
              products: _vm.products,
              campaigns: _vm.conf.campaigns,
              translations: _vm.translations,
              searching: _vm.searchOngoing
            }
          }),
          _vm._v(" "),
          _vm.products.length > 0 && _vm.pageCount > 1
            ? _c("b-pagination", {
                attrs: {
                  align: "center",
                  size: "md",
                  "total-rows": _vm.productCount,
                  "per-page": _vm.productsPerPage,
                  "label-first-page": _vm.translations.gotofirstpage,
                  "label-prev-page": _vm.translations.gotoprevpage,
                  "label-next-page": _vm.translations.gotonextpage,
                  "label-last-page": _vm.translations.gotolastpage,
                  "label-page": _vm.translations.gotopage
                },
                model: {
                  value: _vm.currentPage,
                  callback: function($$v) {
                    _vm.currentPage = $$v
                  },
                  expression: "currentPage"
                }
              })
            : _vm._e()
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "btn-circle",
        attrs: {
          type: "submit",
          name: "product-page-search-submit",
          id: "product-page-search-submit"
        }
      },
      [_c("span", { staticClass: "fas fa-search" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12" }, [
        _c("h2", [_vm._v("Rajaa hakutuloksia:")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [_c("span", { staticClass: "fas fa-angle-down" })])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [_c("span", { staticClass: "fas fa-angle-down" })])
  }
]
render._withStripped = true

export { render, staticRenderFns }